import { useQuery } from "react-query";



import { getCompanies } from "../../../../../MyApi/hr/companies";
import { getBranches } from "../../../../../MyApi/sb/branches";

import LoadingSpinner from "../../../../UI/spinner"
import icons from "../../../../../Data/icons";

import classes from "./addDevice.module.css";

const EditDevice = ({

  deviceName, uuid, major,status, minor,mac,companyId, branchId ,setCompanyId, setStatus ,setMinor  ,setMajor ,setUuid ,setMac, setBranchId ,setDeviceName
}) => {
 

const companyQuery = useQuery("getcompanies" , getCompanies)
const branchQuery = useQuery(["getBranches",companyId ], ()=>getBranches(companyId))


const branches = branchQuery.data?.data || []
const companies =companyQuery.data?.data || []



  const DollarSign = icons.Dollar;
  const Company = icons.company
  const Country = icons.Earth
  const City = icons.City
  const Branch = icons.branch
  const Timezone = icons.timeZone
  const Phone = icons.phone
  const Address = icons.address
  const WorkShift =icons.workShifts
 const Device = icons.device
  const handleNameChange = (e) => {
    setDeviceName(e.target.value);
  };


  const handleBranchIdChange =(e)=>{
    setBranchId(e.target.options[e.target.selectedIndex].id)
  }
  const handleCompanyIdChange =(e)=>{
    setCompanyId(e.target.options[e.target.selectedIndex].id)
  }
  const handleUiidChange =(e)=>{
    setUuid(e.target.value)
  }
 const handleMacChange =(e)=>{
  setMac(e.target.value)
 }
 const handleMajorChange =(e)=>{
  setMajor(e.target.value)
 }
 const handleMinorChange =(e)=>{
  setMinor(e.target.value)
 }
const handleStatusChange =(e)=>{
  setStatus(e.target.value)
}


  return (
    <div className={classes.formCard}>

      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">اسم الجهاز</label>
          <div className={classes.iconInput}>
            <Device />
          </div>
          <input
            type="text"
         value={deviceName}
            placeholder="ادخل اسم الجهاز"
            onChange={handleNameChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">uiid </label>
          <div className={classes.iconInput}>
            <Device />
          </div>
          <input
            type="text"
         value={uuid}

            placeholder=" uiid "
            onChange={handleUiidChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">mac </label>
          <div className={classes.iconInput}>
            <Device />
          </div>
          <input
            type="text"
         value={mac}
            placeholder=" mac "
            onChange={handleMacChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">major </label>
          <div className={classes.iconInput}>
            <Device />
          </div>
          <input
            type="text"
         value={major}
            placeholder="Major"
            onChange={handleMajorChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">minor </label>
          <div className={classes.iconInput}>
            <Device />
          </div>
          <input
            type="text"
         value={minor}
            placeholder="Minor"
            onChange={handleMinorChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">status </label>
          <div className={classes.iconInput}>
            <Device />
          </div>
          <input
            type="text"
         value={status}
            placeholder="Status"
            onChange={handleStatusChange}
            className={classes.inputCustom}
          />
        </div>


        <div className={classes.formCol}>
          <label htmlFor="company">  اختار الشركة</label>
          <div className={classes.iconInput}>
            <Company />
          </div>

        {!companyQuery.data ?<div> no data available</div> :<select
            type="text"
            placeholder="ادخل الرمز التعريفي للدولة"
            onChange={handleCompanyIdChange}
            className={classes.inputCustom}
          >
            <option value="" >اختار الشركة</option>
           {
            companies.map((company)=>(
              <option id={company.id} selected={companyId===company.id } value={company.name}>{company.name}</option>
            ))
           }
          </select>}
        </div>

        <div className={classes.formCol}>
          <label htmlFor="company">  اختار الفرع</label>
          <div className={classes.iconInput}>
            <Branch />
          </div>
       {!branchQuery.data ? <div>no data available </div>:   <select
            type="text"
            onChange={handleBranchIdChange}
            className={classes.inputCustom}
          >
            <option value="" >اختار الفرع</option>
          { branches.map((branch)=>(
            <option key={branch.id}  id={branch.id} selected={branchId ===branch.id} value={branch.name}>{branch.name}</option>
          )) }
          </select>}
        </div>

      
    </div>
    </div>
  );
};

export default EditDevice;
